<template>
  <div v-if="program" class="about " key="detail" :style="style" @touchstart="closeMore">
    <img v-if="program.video !== ''" src="/img/play.png" class="play" alt="" @click="play">
    <div :class="{btns: true, dark: program.dark}">
      <router-link to="/" class="btn">back to entrance</router-link>
      <div class="more">
        <a v-if="program.more !== ''" :href="program.more" target="_blank" class="btn" @touchstart="touch">program information</a>
        <div :class="{details: true, open: detailsOpen, closed: !detailsOpen}" v-if="program.info">
          <div class="div" v-html="program.info.title" />
          <div class="div">{{program.info.sub}}</div>
          <div class="div" v-if="program.info.type">{{program.info.type}}</div>
          <div class="div" v-if="program.info.length">{{program.info.length}}</div>
          <div class="div" v-if="program.info.genre">{{program.info.genre}}</div>
        </div>
      </div>
    </div>
    <div ref="videoContainer" class="videoContainer">
      <video ref="video" :src="program.video" controls disablepictureinpicture controlslist="nodownload"></video>
      <div class="btn skipBtn" @click="skipIntro" v-if="program.intro && !hideSkip">skip intro</div>
      <div class="closeBtn" @click="pause">&times;</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import programs, { Program, ProgramList } from "@/program";

export default defineComponent({
  data(){
    return {
      hideSkip: false,
      detailsOpen: false,
      touchCount: 0,
    }
  },
  mounted(){
    const video = (this.$refs.video as HTMLVideoElement);
    video.addEventListener('timeupdate',()=>{
      if(video.currentTime > (this.program?.intro || 0)){
        this.hideSkip = true;
      } else {
        this.hideSkip = false;
      }
    })
  },
  methods: {
    play(){
      const videoContainer = (this.$refs.videoContainer as HTMLDivElement);
      const video = (this.$refs.video as HTMLVideoElement);
      videoContainer.classList.add('open');
      video.play();
    },
    pause(){
      const videoContainer = (this.$refs.videoContainer as HTMLDivElement);
      const video = (this.$refs.video as HTMLVideoElement);
      videoContainer.classList.remove('open');
      video.pause();
    },
    skipIntro(){
      const video = (this.$refs.video as HTMLVideoElement);
      video.currentTime = this.program?.intro || 0;
      video.play();
    },
    touch(e: TouchEvent){
      e.preventDefault();
      e.stopPropagation();
      if(this.touchCount == 0){
        this.detailsOpen = true;
        this.touchCount = 1;
      } else {
        window.open((e.target as HTMLAnchorElement).href, '_blank');
        this.detailsOpen = false;
        this.touchCount = 0;
      }
    },
    closeMore(){
      this.detailsOpen = false;
      this.touchCount = 0;
    },
  },
  computed: {
    style(): {[key:string]: string}{
      return {
        backgroundImage: `url('/img/film/${this.program?.slug}/room.jpg')`,
      }
    },
    program(): Program | undefined{
      return programs.find( program => program.slug === this.$route.params.id );
    },
  }
});
</script>

<style scoped>
.btn{
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
  border: 1px solid #f32735;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 2vh;
  padding: 1.7vh;
  font-weight: 500;
  transition: transform 0.3s linear;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dark .btn{
  color: #000;
  background-color: rgba(255, 255, 255, 0.45);
}
.btn:hover{
  transform: scale(1.1);
}
.play{
  width: 11vh;
  height: 11vh;
  transition: transform 0.3s linear;
  cursor: pointer;
}
.play:hover{
  transform: scale(1.1);
}
.btns{
  display: flex;
  position: absolute;
  width: 100%;
  bottom: 9vh;
  justify-content: space-between;
  padding: 0 14vh;
}
.flex{
  display: flex;
}
.skipBtn {
  position: absolute;
  right: 12vh;
  bottom: 12vh;
}
.more{
  display: flex;
  position: relative;
}
.more:hover .details, .details.open{
  opacity: 0.7;
}
.details {
  opacity: 0;
  transition: opacity 0.5s linear;
  pointer-events: none;
  position: absolute;
  bottom: calc(100% + 1.6vh);
  width: 110%;
  border: 1px solid #f32735;
  color: #000;
  background-color: #fff;
  transform: translateX(-5%);
}
.details > div{
  font-size: 2vh;
  font-weight: 500;
  padding: 1vh;
  border-bottom: 1px solid #f32735;
}
.details > div:last-child{
  border-bottom: none;
}
.details::before{
  content: "";
  width: 2vh;
  height: 2vh;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateY(50%) translateX(-50%) rotate(45deg);
  border-right: 1px solid #f32735;
  border-bottom: 1px solid #f32735;
  background-color: #fff;
}

@keyframes detailIntro {
  0%   {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes detailOutro {
  0%   {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.about{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  
  animation-name: detailIntro;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}
.fade-leave-active.about{
  animation-name: detailOutro;
}
.videoContainer{
  position: absolute;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: #000;
  opacity: 0;
  transition: opacity 0.5s linear;
  pointer-events: none;
}
.videoContainer.open{
  opacity: 1;
  pointer-events: all;
}
.closeBtn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 50px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
video{
  width: 100%;
  height: 100%;
}
@media (orientation: portrait) {
  video{
    height: 90%;
  }
  .btns {
    padding: 0 8vw;
    bottom: 6vh;
  }
  .btn{
    max-width: 38vw;
  }
}
</style>